// 资质宝路由模块
export default [
	{
		path: '/qualification',
		name: 'Qualification',
		redirect: '/qualification/index',
		component: () => import('@/views/qualification/index'),
		meta: { title: '资质宝' },
		children: [
			{
				path: 'index',
				name: 'QualificationIndex',
				component: () => import('@/views/qualification/home'),
				meta: { title: '资质宝首页', whiteListed: true }
			},
			{
				path: 'maintenance',
				name: 'QualificationMaintenance',
				component: () => import('@/views/qualification/maintenance'),
				meta: { title: '资质维护', whiteListed: false }
			},
			{
				path: 'maintenance-detail/:sslCode',
				name: 'QualificationMaintenanceDetail',
				component: () => import('@/views/qualification/maintenanceDetail'),
				meta: { title: '资质维护详情', whiteListed: false }
			},
			{
				path: 'new',
				name: 'QualificationNew',
				component: () => import('@/views/qualification/new'),
				meta: { title: '资质新办', whiteListed: false }
			},
			{
				path: 'upgrade',
				name: 'QualificationUpgrade',
				component: () => import('@/views/qualification/upgrade'),
				meta: { title: '资质升级', whiteListed: false }
			},
			{
				path: 'renewal',
				name: 'QualificationRenewal',
				component: () => import('@/views/qualification/renewal'),
				meta: { title: '资质延续', whiteListed: false }
			},
			{
				path: 'additional',
				name: 'QualificationAdditional',
				component: () => import('@/views/qualification/additional'),
				meta: { title: '资质增项', whiteListed: false }
			},
			{
				path: 'reEvaluate',
				name: 'QualificationReEvaluate',
				component: () => import('@/views/qualification/reEvaluate'),
				meta: { title: '资质重新核定', whiteListed: false }
			},
			{
				path: 'diagnosticRecordsMore/:mattersType',
				name: 'DiagnosticRecordsMore',
				component: () => import('@/views/qualification/diagnosticRecordsMore'),
				meta: { title: '诊断记录', whiteListed: false }
			},
			{
				path: 'consulting',
				name: 'QualificationConsulting',
				component: () => import('@/views/qualification/consulting'),
				meta: { title: '顾问咨询', whiteListed: false }
			},
			{
				path: 'diagnosis-result',
				name: 'DiagnosisResult',
				component: () => import('@/views/qualification/diagnosisResult'),
				meta: { title: '诊断结果', whiteListed: false }
			},
			{
				path: 'diagnosis-result-detail',
				name: 'DiagnosisResultDetail',
				component: () => import('@/views/qualification/diagnosisResultDetail'),
				meta: { title: '诊断结果详情', whiteListed: false }
			},
			{
				path: 'qualification-materials/:sslCode',
				name: 'QualificationMaterials',
				component: () => import('@/views/qualification/qualificationMaterials'),
				meta: { title: '资质材料提交', whiteListed: false }
			}
		]
	}
]
